import { render } from "./ThePageLoading.vue?vue&type=template&id=5ccbeea0&scoped=true"
const script = {}

import "./ThePageLoading.vue?vue&type=style&index=0&id=5ccbeea0&scoped=true&lang=css"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccbeea0"]])

export default __exports__